import React from 'react';
import styled from 'styled-components';
import { Box, Inline, Link } from '@99designs/emu';
import { boxShadows, colors } from '@99designs/emu/settings';
import { StructuredBriefFile } from '@99designs/graph-utils/types';
import { IconDocument1 } from '@99designs/icons';
import ImageTransparencyTile from '../../../images/ImageTransparencyTile.png';

const ImageTitle = styled(Box)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const File = styled.div`
    height: 128px;
    width: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: ${boxShadows.medium};
    color: ${colors.grey300};
    overflow: hidden;
`;

export interface ViewProps {
    files: StructuredBriefFile[];
}

export default function View({ files }: ViewProps) {
    return (
        <Inline space="1.5bu">
            {files.map((file) => {
                return (
                    <Box key={file.key} maxWidth="128px">
                        <Box>
                            <a href={file.downloadUrl} target="_blank" rel="noreferrer noopener">
                                <File>
                                    {file.previewUrl ? (
                                        <img
                                            aria-labelledby={`file-preview-${file.name}`}
                                            src={file.previewUrl}
                                            width="100%"
                                            style={{
                                                backgroundImage: `url(${ImageTransparencyTile})`,
                                            }}
                                            title={file.name}
                                        />
                                    ) : (
                                        <IconDocument1 height="50%" width="50%" />
                                    )}
                                </File>
                            </a>
                        </Box>
                        <ImageTitle width="100%">
                            <Link
                                id={`file-preview-${file.name}`}
                                href={file.downloadUrl}
                                target="_blank"
                            >
                                {file.name}
                            </Link>
                        </ImageTitle>
                    </Box>
                );
            })}
        </Inline>
    );
}
